import React from 'react'
import { css } from 'aphrodite'
import { Container, Row } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import Sitemap from '../partials/Sitemap'
import SignupForm from './partials/SignupForm'

import style from './style'

const sitemapOptions = [
  { url: '/auth', title: 'Auth' },
  { url: '/signup', title: 'Register' }
]

@inject('Auth')
@observer
export class Register extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        captcha: false
      }
    }
  }

  onInputChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        [e.target.name]: e.target.value
      }
    })
  }

  onFormSubmit (e) {
    e.preventDefault()

    if (!this.state.editor.captcha) {
      return
    }

    this.props.Auth.signup(this.state.editor)
      .then(console.log)
      .catch(console.warn)
  }

  onCaptchaVerify () {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        captcha: true
      }
    })
  }

  render () {
    return [
      <Sitemap key={0} sitemap={sitemapOptions} />,
      <section key={1} className={css(style.main.section)}>
        <Container>
          <Row className={`d-flex align-items-center justify-content-center`}>
            <SignupForm
              editor={this.state.editor}
              onFormSubmit={this.onFormSubmit.bind(this)}
              onInputChange={this.onInputChange.bind(this)}
              onCaptchaVerify={this.onCaptchaVerify.bind(this)}
              response={this.props.Auth.response.register}
            />
          </Row>
        </Container>
      </section>
    ]
  }
}

export default Register



// WEBPACK FOOTER //
// ./src/components/Register/index.js